export abstract class Exception extends Error {
    static readonly NAME: string;

    protected constructor(id: string, type: string, message: string) {
        super();

        this.id = id;
        this.type = type;
        this.message = message;
    }

    /**
     * Уникальный идентификатор ошибки.
     */
    id: string;

    /**
     * Тип ошибки, т.е. имя текущей структуры передающей информацию об ошибке (Exception, ValidationException и т.п.).
     */
    type: string;

    /**
     * Текстовое сообщение об ошибке (nullable).
     */
    message: string;
}
